"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCheckbox = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledCheckbox = (0, styled_components_1.default)(ui_components_1.Checkbox) `
  && {
    display: inline-flex !important;

    &.Mui-disabled {
      color: ${ui_components_1.baseColors.gray200} !important;
    }
  }
`;
